module.exports = __webpack_public_path__ + "media/images/bus/cancel-c12ab91981979b4ce2cefa7cb62f1848.svg";